import $ from 'jquery';

$(function() {
	// mobileMenu();
	// stickyHeader();
	// headerSearch();
	// homeProduct();
	// homeBanners();
	// homeNoticias();
	// genericFoldedList();
	// sideBanners();
	// matchHeightsAutoSelect();
	// matchHeightsByOffsetYAutoSelect();
	// footerToBottom();
});

function headerSearch() {
	var search = $('#divHeaderSearch');
	var open_bt = $('#header_search_bt');
	var close_bt = $('#aHeaderSearchClose');
	open_bt.click( function() {
		search.addClass('Visible');
	});
	close_bt.click( function() {
		search.removeClass('Visible');
	});
}

function homeNoticias() {
	if($('div.HomeNoticias div.BlockRow').length > 1) {
		$('div.HomeNoticias div.BlockRows').cycle( {
			 slides: "> div.BlockRow"
			,timeout: 0
			,speed: 500
			,pause: 1
			,random: 0
			,fx: 'scrollHorz'
			,pager: 'div.HomeNoticiasFooter'
			,sync: true
			,ease: 'linear'
			,pagerActiveClass: 'Active'
			,pagerTemplate: '<a href="javascript:">{{slideNum}}</a>'
			,autoHeight: 'calc'
			,swipe: true
			,swipeFx: 'scrollHorz'
		});
	}
}

function homeProduct() {
	var duration = 300;
	var subhiddenheight = 175;
	var items = $('div.HomeProduct div.Item');
	function onResize() {
		var is_mobile = $('#hamburger').is(':visible')
		items.find('.SubList').height('auto');
		matchHeightsByOffsetY(items.find('> div'));
		if(is_mobile) items.addClass('Mobile');
		else items.removeClass('Mobile');
	}
	$(window).resize(onResize);
	onResize();
	// foreach group then...
	items.each( function() {
		var sub_active = true;
		var sub_height = 0;
		var item = $(this);
		var sublist = item.find('.SubList');
		var image = item.find('.Image');
		function onResize() {
			sublist.css({ height: 'auto' });
			sub_height = Math.max(item.height(), sublist.height());
			sublist.css({ height: sub_height });
			if(!sub_active) {
				sublist.css({ top: -sub_height });
			}
		}
		function openSub() {
			sub_active = true;
			sublist.css({ top: 0 });
			//subopen.addClass("Active");
		}
		function closeSub() {
			sub_active = false;
			sublist.css({ top: -sub_height });
			//subopen.removeClass("Active");
		}
		if(sublist.length > 0) {
			if($('html').hasClass('touchevents')) {
				// nothing
			} else {
				item.on('mouseenter', function() {
					openSub();
				});
				item.on('mouseleave', function() {
					closeSub();
				});
			}
			onResize();
			closeSub();
			$(window).resize(onResize);
		}
		// bind hover of h3 and +info
		item.find('h3 a, p a, .Image a').hover( function(e) {
			if(e.type == 'mouseenter') {
				$(this).parents('.Item').find('h3 a, p a, .Image a').addClass('Hover');
			} else {
				$(this).parents('.Item').find('h3 a, p a, .Image a').removeClass('Hover');
			}
		});
	});

}

function homeBanners()  {
	function onResize() {
		//matchHeightsByOffsetY($('div.HomeBanners div.BlockItem > *'));
	}
	$(window).resize(onResize);
	onResize();
}

function genericFoldedList() {
	$('.FoldedList').each( function() {
		$(this).find('.Sub').each( function() {
			$(this).find('h2').css('cursor', 'pointer');
			$(this).find('h2').click( function() {
				$(this).parents('div.FoldedList').find('div.Sub').find('p').hide();
				$(this).parents('div.FoldedList').find('div.Sub').removeClass('Active');
				$(this).parents('div.Sub').find('p').show();
				$(this).parents('div.Sub').addClass('Active');
			});
			$(this).find('p').hide();
		});
		$(this).find('div.Sub.Active').find('p').show();
	});
}

function footerToBottom() {
	function onResize() {
		var divfoot = $('div.FooterAndBroccoli');
		var divall = $('div.BlockAll');
		var footheight = divfoot.outerHeight();
		var margintop = 14;
		divall.css({
			 'padding-bottom': 0
			,'min-height': 0
		});
		divfoot.removeClass("Absolute");
		if(divall.outerHeight() < $(window).height()) {
			divfoot.addClass("Absolute");
			divall.css({
				 'padding-bottom': footheight + margintop
				,'min-height': $(window).height()
			});
		}
		/*
		if($(this).height() < divall.height() + footheight + margintop) {
			$('body').css('overflow', 'auto');
		} else {
			$('body').css('overflow', 'hidden');
		}
		*/
	}
	$(window).resize(onResize);
	onResize();
	setTimeout(onResize, 100);
}

function sideBanners() {
	function onResize() {
		matchHeightsByOffsetY($('div.SideBanner > *'));
	}
	$(window).resize(onResize);
	onResize();
}

// match heights
// function matchHeightsOfElements(jq_elements) {
// 	var max_height = 0;
// 	jq_elements.each(function() {
// 		$(this).css('height', 'auto');
// 		var height;
// 		if(true && $(this).css('box-sizing') == 'border-box') height = $(this).outerHeight();
// 		else height = $(this).height();
// 		if(height > max_height) max_height = height;
// 	});
// 	jq_elements.css('height', max_height);
// }
function matchHeightsAutoSelect() {
	var data_attr_name = "data-match-heights";
	var groups = [];
	$('*['+data_attr_name+']').each( function() {
		var group_id = $(this).attr(data_attr_name);
		if(-1 == $.inArray(group_id, groups)) groups.push(group_id);
	});
	for(i in groups) {
		// matchHeightsOfElements($('*['+data_attr_name+'="'+group[i]+'"]'));
	}
}
// match heights for elements at the same vertical position
function matchHeightsByOffsetYAutoSelect() {
	var data_attr_name = "data-match-heights-by-offset-y";
	var groups = [];
	$('*['+data_attr_name+']').each( function() {
		var group_id = $(this).attr(data_attr_name);
		if(-1 == $.inArray(group_id, groups)) groups.push(group_id);
	});
	for(i in groups) {
		matchHeightsByOffsetY($('*['+data_attr_name+'="'+group[i]+'"]'));
	}
}
function matchHeightsByOffsetY(jq_elements) {
	var groups = [];
	// first make groups by vertical position
	jq_elements.each( function() {
		var y_offset = $(this).offset().top;
		$(this).attr('data-y-offset', y_offset);
		if(-1 == $.inArray(y_offset, groups)) groups.push(y_offset);
	});
	for(const i in groups) {
		const y_offset = groups[i];
		// matchHeightsOfElements($('*[data-y-offset="'+y_offset+'"]'));
	}
}

/**
 * Make some functions to global
 */
window.matchHeightsByOffsetY = matchHeightsByOffsetY;
